export default __webpack_public_path__ + "static/media/1624.af5a2942.png";